/**
 * @name 无需服务端获取的微应用
 */

export const noAuthApps = [
  {
    name: "auth",
    defaultRegister: true,
    routerBase: "/auth",
    entry: '/FrontAppAuth/',
    entryDev: '//localhost:9001/FrontAppAuth/',
  },
];

export const appList = [
  {
    "name": "systemSetting",
    "entry": "/FrontSystemSetting/",
    "entryDev": "//localhost:9003/FrontSystemSetting/",
    "routerBase": "/systemSetting",
    "defaultRegister": false
  },
  {
    "name": "personAccess",
    "entry": "/FrontPersonaccess/",
    "entryDev": "//localhost:9005/FrontPersonaccess/",
    "routerBase": "/personAccess",
    "defaultRegister": false
  },
  {
    "name": "patrol",
    "entry": "/FrontSecurityProtection/",
    "entryDev": "//localhost:9006/FrontSecurityProtection/",
    "routerBase": "/patrol",
    "defaultRegister": false
  },
  {
    "name": "electFence",
    "entry": "/FrontElectronicFence/",
    "entryDev": "//localhost:9007/FrontElectronicFence/",
    "routerBase": "/electFence",
    "defaultRegister": false
  },
  {
    "name": "workorder",
    "entry": "/FrontWorkorderManagement/",
    "entryDev": "//localhost:9008/FrontWorkorderManagement/",
    "routerBase": "/workorder",
    "defaultRegister": false
  },
  {
    "name": "safePoll",
    "entry": "/FrontSecurityPoll/",
    "entryDev": "//localhost:9009/FrontSecurityPoll/",
    "routerBase": "/safePoll",
    "defaultRegister": false
  },
  {
    "name": "warningCentre",
    "entry": "/FrontWarningCentre/",
    "entryDev": "//localhost:9010/FrontWarningCentre/",
    "routerBase": "/warningCentre",
    "defaultRegister": false
  },
  {
    "name": "interCom",
    "entry": "/FrontIntercomSystem/",
    "entryDev": "//localhost:9090/FrontIntercomSystem/",
    "routerBase": "/interCom",
    "defaultRegister": false
  },
  {
      "name": "pandaTraining",
      "entry": "/FrontPandaTrain/",
      "entryDev": "//localhost:9120/FrontPandaTrain/", 
      "routerBase": "/pandaTraining",
      "defaultRegister": false
  },
  {
    "name": "home",
    "entry": "/FrontHome/",
    "entryDev": "//localhost:9011/FrontHome/",
    "routerBase": "/main",
    "defaultRegister": true
  },
  {
    "name": "alarmManagement",
    "entry": "/FrontAlarmManagement/",
    "entryDev": "//localhost:9012/FrontAlarmManagement/",
    "routerBase": "/alarmManagement",
    "defaultRegister": false
  },
  {
    "name": "decorate-mgt",
    "entry": "/FrontDecoratemgt/",
    "entryDev": "//localhost:9013/FrontDecoratemgt/",
    "routerBase": "/decorateMenu",
    "defaultRegister": false
  },
  {
    "name": "businessManagement",
    "entry": "/FrontBusinessManagement/",
    "entryDev": "//localhost:9024/FrontBusinessManagement/",
    "routerBase": "/businessManagement",
    "defaultRegister": false
  },
  {
    "name": "questionnaire",
    "entry": "/FrontQuestionnaire/",
    "entryDev": "//localhost:9017/FrontQuestionnaire/",
    "routerBase": "/questionnaire",
    "defaultRegister": false
  },
  {
    "name": "parkOperation",
    "entry": "/FrontParkOperation/",
    "entryDev": "//localhost:9019/FrontParkOperation/",
    "routerBase": "/parkOperation",
    "defaultRegister": false
  },
  {
    "name": "householdManagement",
    "entry": "/FrontHouseholdManagement/",
    "entryDev": "//localhost:9018/FrontHouseholdManagement/",
    "routerBase": "/householdManagement",
    "defaultRegister": false
  },
  {
    "name": "onlineService",
    "entry": "/FrontOnlineService/",
    "entryDev": "//localhost:9026/FrontOnlineService/",
    "routerBase": "/onlineService",
    "defaultRegister": false
  },
  {
    "name": "alarmMap",
    "entry": "/FrontAlarmMap/",
    "entryDev": "//localhost:9027/FrontAlarmMap/",
    "routerBase": "/alarmMap",
    "defaultRegister": false
  },
  {
    name: 'zhcfStaticPage',                 // 城服静态页面
    routerBase: '/zhcfStaticPage',         // 子应用激活的规则（会根据路由进行匹配）
    defaultRegister: false,
    entry: '/appZhcfStaticPage/',
    entryDev: '//localhost:9064/appZhcfStaticPage/'
  },
  // {
  //   name: "ifmPm", // ifm保养管理
  //   routerBase: "/ifmPm", // 子应用激活的规则（会根据路由进行匹配）
  //   defaultRegister: false,
  //   entry: "/appIfmPm/",
  //   entryDev: "//localhost:9062/appIfmPm/",
  // },
  {
    "name": "deviceManage",
    "entry": "/FrontDevicemanage/",
    "entryDev": "//localhost:9013/FrontDevicemanage/",
    "routerBase": "/deviceManage",
    "defaultRegister": false
  },
  {
    "name": "statistics",
    "entry": "/FrontStatistics/",
    "entryDev": "//localhost:9028/FrontStatistics/",
    "routerBase": "/statistics",
    "defaultRegister": false
  },
  {
    "name": "carRelease",
    "entry": "/FrontCarRelease/",
    "entryDev": "//localhost:9020/FrontCarRelease/",
    "routerBase": "/carRelease",
    "defaultRegister": false
  },
  {
    "name": "financialManagement",
    "entry": "/FrontFinancialManagement/",
    "entryDev": "//localhost:9025/FrontFinancialManagement/",
    "routerBase": "/financialManagement",
    "defaultRegister": false
  },
  {
    "name": "energyConsumption",
    "entry": "/FrontEnergyConsumption/",
    "entryDev": "//localhost:9029/FrontEnergyConsumption/",
    "routerBase": "/energyConsumption",
    "defaultRegister": false
  },
  {
    "name": "discharged",
    "entry": "/FrontDischarged/",
    "entryDev": "//localhost:9014/FrontDischarged/",
    "routerBase": "/discharged",
    "defaultRegister": false
  },
  {
    "name": "serviceAlarmHost", // 报警主机
    "entry": "/FrontServiceAlarmHost/",
    "entryDev": "//localhost:9110/FrontServiceAlarmHost/",
    "routerBase": "/serviceAlarmHost",
    "defaultRegister": false
  },
  {
    "name": "businessOpportManage",
    "entry": "/FrontBusinessOpportManage/",
    "entryDev": "//localhost:9014/FrontBusinessOpportManage/",
    "routerBase": "/businessOpportManage",
    "defaultRegister": false
  },
  {
    "name": "investmentManagement",
    "entry": "/FrontInvestmentManagement/",
    "entryDev": "//localhost:9014/FrontInvestmentManagement/",
    "routerBase": "/investmentManagement",
    "defaultRegister": false
  },
  {
    "name": "org",
    "entry": "/FrontOrg/",
    "entryDev": "//localhost:9027/FrontOrg/",
    "routerBase": "/org",
    "defaultRegister": false
  },
  {
    "name": "ifmsys",
    "entry": "/FrontIfmsys/",
    "entryDev": "//localhost:9026/FrontIfmsys/",
    "routerBase": "/ifmsys",
    "defaultRegister": false
  },
  {
    "name": "ifmPa",
    "entry": "/FrontIfmPa/",
    "entryDev": "//localhost:9030/FrontIfmPa/",
    "routerBase": "/ifmPa",
    "defaultRegister": false
  },
  {
    "name": "ifmAsset",
    "entry": "/FrontIfmAsset/",
    "entryDev": "//localhost:9040/FrontIfmAsset/",
    "routerBase": "/ifmAsset",
    "defaultRegister": false
  },
  {
    "name": "ifmKbm",
    "entry": "/FrontIfmKbm/",
    "entryDev": "//localhost:9050/FrontIfmKbm/",
    "routerBase": "/ifmKbm",
    "defaultRegister": false
  },
  {
    "name": "ifmPm",
    "entry": "/FrontIfmPm/",
    "entryDev": "//localhost:9062/FrontIfmPm/",
    "routerBase": "/ifmPm",
    "defaultRegister": false
  },
  {
    "name": "ifmInspectionManage",
    "entry": "/FrontIfmInspectionManage/",
    "entryDev": "//localhost:9061/FrontIfmInspectionManage/",
    "routerBase": "/ifmInspectionManage",
    "defaultRegister": false
  },
  {
    "name": "ifmDeviceReport",
    "entry": "/FrontIfmDeviceReport/",
    "entryDev": "//localhost:9063/FrontIfmDeviceReport/",
    "routerBase": "/ifmDeviceReport",
    "defaultRegister": false
  },
  {
    "name": "cloudTest",
    "entry": "/FrontCloudTest/",
    "entryDev": "//localhost:9060/FrontCloudTest/",
    "routerBase": "/cloudTest",
    "defaultRegister": false
  },
  {
    "name": "guardEmploy",
    "entry": "/FrontGuardEmploy/",
    "entryDev": "//localhost:9999/FrontGuardEmploy/",
    "routerBase": "/guardEmploy",
    "defaultRegister": false
  },
  {
    "name": "smartLighting",
    "entry": "/FrontSmartLighting/",
    "entryDev": "//localhost:9015/FrontSmartLighting/",
    "routerBase": "/smartLighting",
    "defaultRegister": false
  },
  {
    "name": "jinmao",
    "entry": "/FrontJinmaoChild/",
    "entryDev": "//localhost:9002/FrontJinmaoChild/",
    "routerBase": "/jinmao",
    "defaultRegister": false
  },
  {
    "name": "environment",
    "entry": "/FrontEnvironment/",
    "entryDev": "//localhost:9030/FrontEnvironment/",
    "routerBase": "/environment",
    "defaultRegister": false
  },
  {
    "name": "upgrade",
    "entry": "/FrontUpgrade/",
    "entryDev": "//localhost:9039/FrontUpgrade/",
    "routerBase": "/upgrade",
    "defaultRegister": false
  },
  {
    "name": "smartHomeAdmin",
    "entry": "/FrontSmartHomeAdmin/",
    "entryDev": "//localhost:9041/FrontSmartHomeAdmin/",
    "routerBase": "/smartHomeAdmin",
    "defaultRegister": false
  },
  {
    "name": "attendance",
    "entry": "/FrontGuardAttendance/",
    "entryDev": "//localhost:9989/FrontGuardAttendance/",
    "routerBase": "/guardAttendance",
    "defaultRegister": false
  },
  {
    "name": "knowledge",
    "entry": "/FrontKnowledge/",
    "entryDev": "//localhost:9036/FrontKnowledge/",
    "routerBase": "/knowledge",
    "defaultRegister": false
  },
  {
    "name": "iotAdmin",
    "entry": "/FrontIotAdmin/",
    "entryDev": "//localhost:9801/FrontIotAdmin/",
    "routerBase": "/iotAdmin",
    "defaultRegister": false
  },
  {
    "name": "propertyEvaluation",
    "entry": "/FrontPropertyEvaluation/",
    "entryDev": "//localhost:9069/FrontPropertyEvaluation/",
    "routerBase": "/propertyEvaluation",
    "defaultRegister": false
  },
  {
    "name": "processConfig",
    "entry": "/FrontApprovalManagement/",
    "entryDev": "//localhost:9040/FrontApprovalManagement/",
    "routerBase": "/processConfig",
    "defaultRegister": false
  },
  {
    "name": "approvalManagement",
    "entry": "/FrontApprovalManagement/",
    "entryDev": "//localhost:9040/FrontApprovalManagement/",
    "routerBase": "/approvalManagement",
    "defaultRegister": false
  },
  {
    "name": "visualConfig",
    "entry": "/FrontVisualConfig/",
    "entryDev": "//localhost:9093/FrontVisualConfig/",
    "routerBase": "/visualConfig",
    "defaultRegister": false
  },
  {
    "name": "meeting",
    "entry": "/FrontMeeting/",
    "entryDev": "//localhost:9042/FrontMeeting/",
    "routerBase": "/meeting",
    "defaultRegister": false
  },
  {
    "name": "fireProtection",
    "entry": "/FrontFireProtection/",
    "entryDev": "//localhost:9119/FrontFireProtection/",
    "routerBase": "/fireProtection",
    "defaultRegister": false
  },
  {
    "name": "operationsManagement",
    "entry": "/FrontOperationsManagement/",
    "entryDev": "//localhost:9016/FrontOperationsManagement/",
    "routerBase": "/operationsManagement",
    "defaultRegister": false
  },
  {
    "name": "iotProjectDevices",
    "entry": "/FrontIotProjectDevices/",
    "entryDev": "//localhost:9805/FrontIotProjectDevices/",
    "routerBase": "/iotProjectDevices",
    "defaultRegister": false
  },
  {
    "name": "iotScene",
    "entry": "/FrontIotSceneManage/",
    "entryDev": "//localhost:9805/FrontIotSceneManage/",
    "routerBase": "/iotScene",
    "defaultRegister": false
  },
  {
    "name": "dynamicForm",
    "entry": "/FrontDynamicForm/",
    "entryDev": "//localhost:9070/FrontDynamicForm/",
    "routerBase": "/dynamicForm",
    "defaultRegister": false
  },
  {
    "name": "spaceManagement", // 空间管理子应用
    "entry": "/FrontPlatformSpaceManagement/",
    "entryDev": "//localhost:9210/FrontPlatformSpaceManagement/",
    "routerBase": "/spaceManagement",
    "defaultRegister": false
  },
  {
    "name": "constructionFifthBureau", // 招商管理
    "routerBase": "/constructionFifthBureau",
    "defaultRegister": false,
    "entry": "/FrontConstructionFifthBureau/",
    "entryDev": "//localhost:9088/FrontConstructionFifthBureau/"
  },
  {
    "name": "dataRoom", // 可视化平台
    "routerBase": "/dataRoom", // 子应用激活的规则（会根据路由进行匹配）
    "defaultRegister": false,
    "entry": "/appDataRoom/",
    "entryDev": "//localhost:9055/appDataRoom/",
  },
  {
    "name": "zhcfStaticPage",                 // 城服静态页面
    "routerBase": "/zhcfStaticPage",
    "entry": "/FrontZhcfStaticPage/",
    "entryDev": "//localhost:9064/FrontZhcfStaticPage/",
    "defaultRegister": false
  },
  {
    "name": "jqStaticPage",                   // 景区静态页面
    "routerBase": "/jqStaticPage",
    "entry": "/FrontJqStaticPage/",
    "entryDev": "//localhost:9065/FrontJqStaticPage/",
    "defaultRegister": false
  },
]
